import { useMemo } from 'react';
import { useChgState } from './useChgState.js';
/**
 * Similar to `useToggleState`, but without the toggle fn since it isn't used
 * particularly frequently.
 * @see useToggleState
 */
export const useBoolState = (initValue) => {
    const [state, setState] = useChgState(initValue);
    const [toggleTrue, toggleFalse] = useMemo(() => [
        /* toggleTrue */
        () => setState(true),
        /* toggleFalse */
        () => setState(false),
    ], []);
    return [state, toggleTrue, toggleFalse];
};
//# sourceMappingURL=useBoolState.js.map